
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import mixin from "./mixin";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule } from "@/store/modules/";
import notifications from "@/lib/notifications";
import * as modals from "@/lib/modals";
import DateRange from "../DateRange.vue";
import { DeliveryExportRequest, DeliveryExportFormat } from "@/models/api/orders/deliveryExport";
import Select from "@/components/form/Select.vue";
import { AccountModule } from "@/store/modules";

@Component({
  name: modals.deliveryExportModal,
  components: { Select }
})
export default class DeliveryExportModal extends Mixins(mixin) {
  @Ref() readonly deliveryDateRange!: DateRange;

  accountModule: AccountModule = getModule(AccountModule);
  orderModule: OrderModule = getModule(OrderModule);
  systemModule: SystemModule = getModule(SystemModule);

  supportedFormats: any[] = [];
  format: string = null;
  deliveryDateRangeValue: any = null;
  facilityCode: string = null;

  async created() {
    try {
      const response = await this.orderModule.getDeliveryExportFormats();
      this.supportedFormats = response.map(x => ({
        label: x.description,
        value: x.format
      }));

      if (this.systemModule.facilities && this.systemModule.facilities.length == 1)
        this.facilityCode = this.systemModule.facilities[0].facilityCode;
      else
        this.facilityCode =
          this.accountModule.deliveryExportFacilityCodeUserSettings &&
          this.accountModule.deliveryExportFacilityCodeUserSettings.length > 0
            ? this.accountModule.deliveryExportFacilityCodeUserSettings[0]
            : null;

      this.format =
        this.accountModule.deliveryExportFormatUserSettings &&
        this.accountModule.deliveryExportFormatUserSettings.length > 0
          ? this.accountModule.deliveryExportFormatUserSettings[0]
          : null;
    } catch (ex) {
      notifications.error(
        "Delivery Export Formats",
        "Failed to load delivery export format list",
        ex
      );
    }
  }

  load() {
    this.show();
  }

  reset() {
    this.deliveryDateRangeValue = null;
    this.facilityCode =
      this.accountModule.deliveryExportFacilityCodeUserSettings &&
      this.accountModule.deliveryExportFacilityCodeUserSettings.length > 0
        ? this.accountModule.deliveryExportFacilityCodeUserSettings[0]
        : null;

    this.format =
      this.accountModule.deliveryExportFormatUserSettings &&
      this.accountModule.deliveryExportFormatUserSettings.length > 0
        ? this.accountModule.deliveryExportFormatUserSettings[0]
        : null;
  }

  async exportDeliveries() {
    let dateRange = this.deliveryDateRange.dateRange;

    if (dateRange && dateRange.end != null && this.facilityCode && this.format) {
      let request: DeliveryExportRequest = {
        format: this.format,
        facilityCode: this.facilityCode,
        deliveryDateStart: dateRange.start,
        deliveryDateEnd: dateRange.end
      };

      try {
        await this.orderModule.exportDeliveryExport(request);

        this.accountModule.updateUserSettings({
          settingName: "deliveryExportFormat",
          values: [this.format]
        });
        this.accountModule.updateUserSettings({
          settingName: "deliveryExportFacilityCode",
          values: [this.facilityCode]
        });
      } catch (ex) {
        notifications.error("Delivery Export", "Failed to export deliveries", ex);
      }
    }
  }

  get showFacilitySelect() {
    return this.systemModule.facilities && this.systemModule.facilities.length != 1;
  }
}
